import React from 'react';
import Icon from '@ant-design/icons';

const DuplicateSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Duplicate</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon-/-Duplicate" stroke="currentColor">
        <rect id="Rectangle" x="5.5" y="5.5" width="10" height="10" rx="2" />
        <path
          d="M2.80769231,10.5 L2.03846154,10.5 C1.18879269,10.5 0.5,9.81120731 0.5,8.96153846 L0.5,2.03846154 C0.5,1.18879269 1.18879269,0.5 2.03846154,0.5 L8.96153846,0.5 C9.81120731,0.5 10.5,1.18879269 10.5,2.03846154 L10.5,2.80769231"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

export const JDuplicate: React.FC<any> = (props) => {
  return <Icon component={DuplicateSVG} {...props}  aria-hidden={true}/>;
};
